import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_URL, API_URL_OPTIONS } from '../../../../../shared/config/constants';
import { Container, GetContainersParams } from '../../../types';

// Define a service using a base URL and expected endpoints
export const containerApi = createApi({
  reducerPath: 'containerApi',
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    getContainers: builder.query<Container[], GetContainersParams>({
      query: ({ lat, lng, municipality_id }) => ({
        url: `/v1/waste/locations/${municipality_id}/${lat}/${lng}`,
        ...API_URL_OPTIONS,
      }),
    }),
  }),
});
